import script from "./SwitchView.vue?vue&type=script&setup=true&lang=js"
export * from "./SwitchView.vue?vue&type=script&setup=true&lang=js"

import "./SwitchView.vue?vue&type=style&index=0&id=7c3a654e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7c3a654e"]])

export default __exports__